import { Checkbox, FormControlLabel, makeStyles, styled, Typography } from '@material-ui/core';
import React from 'react';

const CustomStyledCheckbox = styled(Checkbox)(({ indeterminate }) => ({
  cursor: 'pointer',
  color: 'rgba(208, 213, 221, 1)',
  '&.Mui-checked': {
    color: 'rgba(98, 47, 238, 1)',
  },
  ...(indeterminate && {
    color: 'rgba(98, 47, 238, 1)',
    '&.Mui-checked': {
      color: 'rgba(98, 47, 238, 1)',
    },
  }),
}));

const useStyle = makeStyles({
  label: {
    fontFamily: 'Lato',
    fontSize: ({ size }) => size || '12px',
    fontWeight: ({ weight }) => weight || '500',
    lineHeight: '19.6px',
    textAlign: 'left',
  },
});

const CustomCheckbox = ({ label, size, weight, handleChange, name, value, selected, disabled, indeterminate }) => {
  const classes = useStyle({ size, weight });
  return (
    <FormControlLabel
      control={
        <CustomStyledCheckbox
          disableRipple
          disabled={disabled}
          checked={selected}
          indeterminate={indeterminate}
          name={name}
          value={value}
          onChange={handleChange}
          className={classes.checkbox}
        />
      }
      label={<Typography className={classes.label}>{label}</Typography>}
      style={{ alignItems: 'center' }}
    />
  );
};

export default CustomCheckbox;
